
import AepsCashMain from "../../components/aeps-cash-Deposit-reports/AepsCashMain"

export const AEPSCashReport = ({ title_1, title_2, title }) => {
   
    return <div>
        <AepsCashMain title_1={title_1} title_2={title_2} title={title} />
    </div>
}